import React from 'react';

import { Button, SvgIcon, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

import { Stack } from '@/components/layout';
import { OnboardingCallout } from './onboarding-callout';

const strings = STRINGS.onboarding.finish;

type OnboardingInviteCoGuardianProps = {
  /** Fired when the guardian taps "Invite" (co-guardian invite flow is TBD). */
  onInvite?: () => void;
};

/**
 * "Invite a Co-guardian" prompt shown on the finish screen. Reuses the shared
 * {@link OnboardingCallout} frame (same as the notice / add-child cards): a mail
 * icon, the invite blurb, and a trailing "Invite" button.
 */
export function OnboardingInviteCoGuardian({ onInvite }: OnboardingInviteCoGuardianProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <OnboardingCallout align="center" gap={scale(10)}>
      <Stack height={'100%'} paddingTop={scale(2)}>
        <SvgIcon name="IcMailLove01" size={scale(24)} color={guardianColors['Main/Main']} />
      </Stack>
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Regular" style={styles.text}>
        {strings.inviteText}
      </Text>
      <Button onPress={onInvite} style={styles.button}>
        <Button.Text
          variant="Font Guardian App/Subtitle/Subtitle 14 Semibold"
          style={styles.buttonLabel}>
          {strings.invite}
        </Button.Text>
      </Button>
    </OnboardingCallout>
  );
}

const useStyles = createStyles(({ scale }) => ({
  text: {
    flex: 1,
    color: colors['10'],
  },
  button: {
    paddingHorizontal: scale(20),
    borderRadius: 12,
    backgroundColor: guardianColors['Main/Main'],
  },
  buttonLabel: {
    color: colors['0'],
  },
}));

export default OnboardingInviteCoGuardian;
